import * as React from 'react';
type Props = {
  className?: string;
};
export function Coconut({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Coconut"
      className={className}
    >
      <path
        d="M11.9969 25.4123C12.386 25.4123 12.7014 25.1024 12.7014 24.7202C12.7014 24.338 12.386 24.0282 11.9969 24.0282C11.6077 24.0282 11.2923 24.338 11.2923 24.7202C11.2923 25.1024 11.6077 25.4123 11.9969 25.4123Z"
        fill="currentColor"
      />
      <path
        d="M9.09008 28.203C9.4792 28.203 9.79466 27.8931 9.79466 27.5109C9.79466 27.1287 9.4792 26.8188 9.09008 26.8188C8.70095 26.8188 8.3855 27.1287 8.3855 27.5109C8.3855 27.8931 8.70095 28.203 9.09008 28.203Z"
        fill="currentColor"
      />
      <path
        d="M13.0432 30.1386C13.4324 30.1386 13.7478 29.8287 13.7478 29.4465C13.7478 29.0642 13.4324 28.7545 13.0432 28.7545C12.6541 28.7545 12.3386 29.0642 12.3386 29.4465C12.3386 29.8287 12.6541 30.1386 13.0432 30.1386Z"
        fill="currentColor"
      />
      <path
        d="M20.0044 4.10376C13.4882 4.10376 9.68972 7.98233 8.97598 8.66078C2.09181 15.6487 4.1985 22.829 4.682 24.6155C5.45331 26.9449 4.1064 28.3357 5.02736 29.6587C6.25915 31.4226 7.89385 30.8007 9.56309 32.3612C18.6461 39.5074 27.7981 34.928 28.7191 34.4304C31.4243 32.9604 33.1397 31.0608 34.0606 29.8509M20.0044 4.10376C19.3368 4.21694 18.6806 4.43171 18.0705 4.74836C14.8586 6.3992 13.4542 10.4813 14.0413 15.1851C14.3406 17.5145 15.1234 20.0021 16.4127 22.422C20.3038 29.7039 27.3492 33.5936 32.1612 31.1173C35.0046 29.6587 36.4206 26.289 36.3055 22.2862C36.2249 19.5046 35.4075 16.429 33.8189 13.4439C30.7336 7.6884 25.6799 4.03613 21.3169 4.00217C20.9255 3.99085 20.5341 4.02481 20.1542 4.08112C20.1082 4.09272 20.062 4.09271 20.0044 4.10376ZM29.3054 26.1687C32.1345 24.7099 32.4061 19.7444 29.912 15.0779C27.4179 10.4113 23.1026 7.81087 20.2736 9.26963C17.4445 10.7284 17.1729 15.6939 19.667 20.3605C22.1611 25.0271 26.4763 27.6275 29.3054 26.1687ZM11.9969 25.4123C12.386 25.4123 12.7014 25.1024 12.7014 24.7202C12.7014 24.338 12.386 24.0282 11.9969 24.0282C11.6077 24.0282 11.2923 24.338 11.2923 24.7202C11.2923 25.1024 11.6077 25.4123 11.9969 25.4123ZM9.09008 28.203C9.4792 28.203 9.79466 27.8931 9.79466 27.5109C9.79466 27.1287 9.4792 26.8188 9.09008 26.8188C8.70095 26.8188 8.3855 27.1287 8.3855 27.5109C8.3855 27.8931 8.70095 28.203 9.09008 28.203ZM13.0432 30.1386C13.4324 30.1386 13.7478 29.8287 13.7478 29.4465C13.7478 29.0642 13.4324 28.7545 13.0432 28.7545C12.6541 28.7545 12.3386 29.0642 12.3386 29.4465C12.3386 29.8287 12.6541 30.1386 13.0432 30.1386Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
